import { put, call } from "redux-saga/effects";
import IRequestAction from "../../../interfaces/IRequestAction";

import history from "../../../services/history";

import { Creators as expensesActions } from "../../ducks/expenses";

export function* createExpense(action: IRequestAction) {
    try {
        const { payload } = action;

        yield put(expensesActions.createExpenseSuccess(payload));

        yield call(history.push, { pathname: `/app` });
    } catch (error) {
        console.log(error);
        // yield put(alertActions.showAlert("Registro não encontrado.", "danger"));
        // yield put(filesActions.getFileFailure());
        // yield call(history.push, { pathname: `/app/arquivos` });
    }
}

export function* deleteExpense(action: IRequestAction) {
    try {
        const { payload } = action;

        yield put(expensesActions.deleteExpenseSuccess(payload));

        yield call(history.push, { pathname: `/app` });
    } catch (error) {
        console.log("deleteExpense error", error);
        // yield put(alertActions.showAlert("Registro não encontrado.", "danger"));
        // yield put(filesActions.getFileFailure());
        // yield call(history.push, { pathname: `/app/arquivos` });
    }
}
